import { Constants } from 'app/utility/constants';
import { MenuService } from 'app/services/menu.service';
import { UserService } from 'app/services/user.service';
import { Component, Input } from '@angular/core';
import { PopoverController, NavController } from '@ionic/angular';
import { OpportunityModel } from 'app/models/dms/opportunity.model';
import { StorageService } from 'app/services/storage.service';

import { Browser } from '@capacitor/browser';

@Component({
    template: `
	@if (serviceMenuItemRows && serviceMenuItemRows.length) {
	  <ion-grid>
	    @for (serviceMenuItemCols of serviceMenuItemRows; track serviceMenuItemCols) {
	      <ion-row>
	        @for (serviceMenuItem of serviceMenuItemCols; track serviceMenuItem) {
	          <ion-col
	            [class]="'mn-menu-col mn-menu-'+serviceMenuItem.area"
	            [class.active]="this.menuService.area==serviceMenuItem.area"
	            (click)="loadTheLink(serviceMenuItem)"
	            >
	            <ion-avatar>
	              @if (serviceMenuItem.area=='user') {
	                <div [class]="contactColorClass" >{{this.initials}}</div>
	              }
	              @if (serviceMenuItem.area!='user') {
	                <span [class]="'mc-icon ' + serviceMenuItem.icon"></span>
	              }
	            </ion-avatar>
	            <ion-label >{{serviceMenuItem.label}}</ion-label>
	          </ion-col>
	        }
	      </ion-row>
	    }
	  </ion-grid>
	}
	`,
    standalone: false
})

export class HeaderPopover
{
	constructor(
		private popoverCtrl: PopoverController,
		private navCtrl: NavController,
		private userService: UserService,
		public menuService: MenuService,
		private storage: StorageService
	)
	{
	}

	initials: string;
	contactColorClass: string;
	serviceMenuItemRows: any[];
	async ngOnInit() 
	{
		this.storage.get(Constants.IonicStorage_Initials, false).then((val) =>
		{
			this.initials = val;
			if (!this.initials) this.initials = "U";
		});

		this.contactColorClass = this.menuService.getContactColorClass(this.initials);

		var menuitems = [];


		menuitems.push(new ServiceMenuItem("icon-user", "My account", "user", false));
		menuitems.push(new ServiceMenuItem("icon-logout", "Sign out", "logout", true));
		menuitems.push(new ServiceMenuItem("icon-MC-DMS", "DMS", "dms", true));
		menuitems.push(new ServiceMenuItem("icon-AutoAttendant", "Auto Attendant", "autoattendant", true));
		menuitems.push(new ServiceMenuItem("icon-CarCheck", "Car Check", "carcheck", true));
		menuitems.push(new ServiceMenuItem("icon-VehicleXchange", "VehicleXchange", "wholesale", true));
		menuitems.push(new ServiceMenuItem("icon-Buyerscore", "BuyerScore", "buyerscore", true));
		menuitems.push(new ServiceMenuItem("icon-finance-central-circle", "Avanti Finance", "finance", true));
		// menuitems.push(new ServiceMenuItem("icon-AMPD-round-icon", "AMPD CRM", "https://www.motorcentral.co.nz/ampd", true));

		// menuitems.push(new ServiceMenuItem("icon-AMPD-round-icon", "AMPD CRM", "https://www.motorcentral.co.nz/ampd", true));


		//menuitems.push(new ServiceMenuItem("icon-AdConnect", "AdConnect", "https://www.motorcentral.co.nz/adconnect", true));


		this.serviceMenuItemRows = this.ChunkArray(menuitems, 2);

	}

	error: boolean = false;
	@Input() opportunity: OpportunityModel;

	async onDismiss()
	{
		try
		{
			await this.popoverCtrl.dismiss();
		} catch (e)
		{
			//click more than one time popover throws error, so ignore...
		}
	}

	async performAction(action: string)
	{
		try
		{
			await this.popoverCtrl.dismiss(action);
		} catch (e)
		{
			//click more than one time popover throws error, so ignore...
		}
	}
	async loadTheLink(menuItem: ServiceMenuItem)
	{
		try
		{
			await this.popoverCtrl.dismiss(menuItem.area);
		} catch (e)
		{
			//click more than one time popover throws error, so ignore...
		}
		if (menuItem.area.startsWith("https"))
		{
			await Browser.open({ url: menuItem.area });
		}
		else if (menuItem.area == "logout")
		{
			this.userService.confirmLogout()
		}
		else if (menuItem.root)
		{
			this.navCtrl.navigateRoot('/' + (menuItem.area == "dms" ? "vehicles" : menuItem.area));
		}
		else
		{
			this.navCtrl.navigateForward(menuItem.area);
		}
	}
	ChunkArray(myArray: ServiceMenuItem[], chunk_size: number): any[]
	{
		var index = 0;
		var arrayLength = myArray.length;
		var serviceMenuItemRows = [];

		for (index = 0; index < arrayLength; index += chunk_size)
		{
			var cols = myArray.slice(index, index + chunk_size);
			// Do something if you want with the group
			serviceMenuItemRows.push(cols);
		}

		return serviceMenuItemRows;
	}
}

export class ServiceMenuItem
{
	constructor(icon: string, label: string, area: string, root: boolean = false, iconDark?: string)
	{
		this.icon = icon;
		this.iconDark = iconDark;
		this.label = label;
		this.area = area;
		this.root = root;
	}

	icon: string;
	iconDark?: string;
	label: string;
	area: string;
	root: boolean = false;
}